var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(!_vm.loading)?_c('ff-button',{class:_vm.classes,attrs:{"action":_vm.connect,"text":_vm.text,"icon":'payments'}}):_vm._e(),(_vm.loading)?_c('ff-inline-loading',{attrs:{"saving":_vm.loading,"full":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }